import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import HeaderBread from "../../../components/HeaderBread";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";

import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import { message, Tag } from "antd";
import moment from "moment";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import CustomizedTable from "../../../components/UI/CustomizedTable";
import { getSailingPageData } from "../../../utils/ApiCalls/SailingData";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { getVessels } from "../../../utils/ApiCalls/SpecialPage";
import Swal from "sweetalert2";
import CustomizedData from "../../../components/UI/CustomizedData";
import SwitchBar from "../../../components/Pages/SwitchBar";
import SailingToggle from "../../../components/SailingPage/SailingToggle";
import { getCurrentActiveSailing } from "../../../utils/ApiCalls/SailingData/index";
import Logs from "../../../components/Logs";

const SailingDateData = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [navigation, setNavigation] = useState([]);
  const [activePackage, setActicePackage] = useState({});

  const [rows, setRows] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const [status, setStatus] = useState("all");
  const [vessel, setVessel] = useState();
  const [count, setCount] = useState(0);
  const [{ permission, userDetails }, dispatch] = useDataLayerValue();

  const location = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(location.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(location.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(location.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;
    const searchParam = params.get("search") || "";

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
    setSearch(searchParam);
  }, [location.search, params.vessel]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(location.search);

    params.set("page", page);
    params.set("pageSize", pageSize);
    if (search) params.set("search", search);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, search, navigate]);
  const columns = [
    {
      title: "Sl",
      width: 30,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Pages",
      width: 30,
      dataIndex: "page_count",
      key: "page_count",
    },
    {
      title: "Sailing date",
      dataIndex: "sailing_date",
      key: "sailing_date",
      width: 50,
      render: (item) => moment(item).format("DD-MM-YYYY"),
    },

    {
      title: "Action",
      key: "operation",
      width: 100,
      render: (text, record) => (
        <div className="table_action_btn">
          <Button
            variant="contained"
            className=""
            onClick={() => handleEdit(record.id)}
          >
            Manage Sailing
          </Button>
          <Button
            variant="contained"
            onClick={() => handleDuplicate(record.id)}
          >
            Duplicate Sailing
          </Button>
        </div>
      ),
    },
  ];
  
  useEffect(() => {
    if (vessel) getData(page);
  }, [page, pageSize, vessel, status, activePackage?.packageId]);

  useEffect(() => {
    setNavigation([
      {
        title: "Home",
        route: "/",
      },
      {
        title: vessel?.name,
        route: "/website/cms/news-letter",
      },
    ]);
  }, [vessel]);

  useEffect(() => {
    if (params?.vessel) {
      getOptionLocation();
    }
  }, [params]);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();

    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVessel(
        vessels.find(
          (item) =>
            item.name.toLowerCase().replaceAll(" ", "-") == params?.vessel
        )
      );
      setVesselOptions(vessels);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const getData = async (value) => {
    let dataQuery = {
      page: value,
      limit: pageSize,
      vessel_id: vessel.id,
      sort:'sailing_date'
    };

    if (status != "all") {
      dataQuery.status = status;
    } else {
      delete dataQuery?.status;
    }
    let data = await getSailingPageData(dataQuery);
    let activeSailingData = await getCurrentActiveSailing(vessel.id);

    if (data.error)
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      setActicePackage(activeSailingData);
    }
  };

  const handleEdit = async (id) => {
    if (
      checkPermission(
        permission,
        "update_per",
        vessel?.name,
        window.location.pathname
      )
    ) {
      navigate(`/shore/cruise-page/${params.vessel}/edit/` + id + `${location.search}`);
    } else {
      message.error("Update permission missing");
    }
  };
  const handleDuplicate = async (id) => {
    if (
      checkPermission(
        permission,
        "update_per",
        vessel?.name,
        window.location.pathname
      )
    ) {
      navigate(`/shore/cruise-page/${params.vessel}/duplicate/` + id + `${location.search}`);
    } else {
      message.error("Update permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={vessel?.name}>
      <CustomHeaderTitle title={vessel?.name} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={vessel?.name}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header two_item">
                <h5 className="card-title">{vessel?.name} List</h5>
                <div className="two_item">
                  <Link
                    to={`/shore/cruise-page/${params.vessel}/add${location.search}`}
                    className="btn add_v_btn mx-2"
                  >
                    Add Cruise
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <SwitchBar
                  tabs={[
                    { title: "All", value: "all" },
                    { title: "Active Cruise", value: "active" },
                    // { title: "Upcomming Cruise", value: "upcomming" },
                    { title: "Completed Cruise", value: "completed" },
                    { title: "Draft Cruise", value: "draft" },
                    { title: "History Logs", value: "logs" },
                  ]}
                  activeTab={status}
                  setActiveTab={setStatus}
                />
                {status !== "logs" && (
                  <div className="table_holder">
                  <CustomizedData
                    setRows={setRows}
                    setPageSize={setPageSize}
                    setPage={setPage}
                    render={(page, index) => (
                      <Card
                        key={page.id}
                        variant="outlined"
                        sx={{ mb: 2, border: "1px solid black" }}
                      >
                        <CardContent
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1,
                          }}
                        >
                          <Box>
                            <Box
                              sx={{
                                display: "flex",
                                width: "100%",
                                alignItems: "flex-start",
                                gap: "10px",
                              }}
                            >
                              <Box>
                                <h5 style={{ fontWeight: "bold" }}>
                                  {moment(page?.sailing_date).format("DD MMM")} to {moment(page?.sailing_date).add(page?.duration || 0, 'days').format("DD MMM YYYY")} /
                                  {" " + page?.duration} Nights
                                </h5>

                                <h6>{page?.page_count || 0} Page Assigned</h6>
                              </Box>
                              {/* Computed Status */}
                              <Tag
                                color={
                                  page?.status === "active"
                                    ? "green"
                                    : page?.status === "upcoming"
                                      ? "blue"
                                      : page?.status === "completed"
                                        ? "red"
                                        : "default"
                                }
                              >
                                {page?.status
                                  ? page.status.charAt(0).toUpperCase() +
                                  page.status.slice(1)
                                  : ""}
                              </Tag>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                gap: "10px",
                                marginTop: "10px",
                              }}
                            >
                              {(page.status == "draft" ||
                                page.status == "active") && (
                                  <Button
                                    variant="contained"
                                    className=""
                                    onClick={() => handleEdit(page.id)}
                                  >
                                    Manage Cruise Content
                                  </Button>
                                )}
                              {page?.status == "completed" && (
                                <Button
                                  variant="contained"
                                  onClick={() => handleDuplicate(page.id)}
                                >
                                  Duplicate Sailing
                                </Button>
                              )}
                            </Box>
                          </Box>
                          <SailingToggle
                            data={page}
                            activeSailing={activePackage}
                            setActiveSailing={setActicePackage}
                            isEditable={true}
                            enableDelete={page.enableDelete}
                            getData={getData}
                            page_count={page.page_count || 0}
                          />
                        </CardContent>
                      </Card>
                    )}
                    pageSize={pageSize}
                    page={page}
                    count={count}
                    columns={columns}
                    rows={rows}
                    title={vessel?.name}
                  />
                </div>
                )}
              </div>
            </div>
            {status === "logs" && (
              <Logs
                type={"Cruise"}
                slug={`/shore/cruise-page/${params.vessel}/edit/`}
              />
            )}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default SailingDateData;
